


















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { VideoApi } from "@/api/videoApi";
import { isLogin, getImagePath } from "@/utils/utils";
import { message } from "ant-design-vue";
import { CommonApi } from "@/api/commonApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class VideoDetail extends Vue {
  videoApi: VideoApi;
  commonApi: CommonApi;
  id: number;
  videoUrl: string | undefined = "";
  posterUrl: string | undefined = "";
  info = {};
  playerOptions = {};
  nextList = [];
  customerName: string | null = "";
  customerAva: string | null =
    process.env.VUE_APP_IMG_HOST + "/Images/userAva.png";
  isLogin = false;
  wxLoginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wxda87ecd6150c5b3d&redirect_uri=${encodeURIComponent(
    process.env.VUE_APP_HOST_URL
  )}&response_type=code&scope=snsapi_login&state=STATE`;
  commentStr = "";
  parentId = 0;
  commentList: Array<object> = [];
  adInfo = {};
  refNews: Array<any> = [];
  refImageText: Array<any> = [];
  refDic: Array<any> = [];
  refVideo: Array<any> = [];
  refBook: Array<any> = [];
  comments: Array<any> = [];

  constructor() {
    super();
    this.videoApi = new VideoApi();
    this.commonApi = new CommonApi();
    this.id = Number(this.$route.query["id"]);
  }
  mounted() {
    this.initData();
    this.isLogin = isLogin();
    if (this.isLogin) {
      this.customerName = sessionStorage.getItem("nickName");
      this.customerAva = getImagePath(sessionStorage.getItem("avaUrl"));
    }
  }

  @Watch("$route")
  getRoute(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      this.id = Number(newVal.query.id);
      this.initData();
    }
  }

  initData() {
    this.getVideoInfo();
    this.getNextList();
    this.getAdInfo();
    this.getExtInfo();
  }

  getExtInfo() {
    this.videoApi.getExtInfo(this.id).then((res) => {
      this.refNews = res.data.refNews;
      this.refImageText = res.data.refImageText;
      this.refDic = res.data.refDic;
      this.refVideo = res.data.refVideo;
      this.refBook = res.data.refBook;
    });
  }

  getAdInfo() {
    this.commonApi.getAdInfo(2).then((res) => {
      this.adInfo = res.data;
    });
  }

  getVideoInfo() {
    this.videoApi.getVideoDetail(this.id).then((res) => {
      this.info = res.data.info;
      this.commentList = res.data.comments;
      this.videoUrl = getImagePath(res.data.info.VideoUrl);
      this.posterUrl = getImagePath(res.data.info.VideoImage);
      this.playerOptions = {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: this.videoUrl, // url地址
          },
        ],
        hls: true,
        poster: this.posterUrl, // 你的封面地址
        // poster:
        //   "http://cdn.eatgreen.cn/Upload/20200507/54b44b51-b71f-4dd3-a3c8-bc5ae1ffa4a5.png",
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true, // 全屏按钮
        },
      };
    });
  }

  getNextList() {
    this.videoApi.getNextList(this.id).then((res) => {
      this.nextList = res.data;
    });
  }

  comment() {
    if (this.commentStr.trim().length > 0) {
      this.videoApi
        .comment(this.id, this.commentStr, this.parentId)
        .then((res) => {
          message.success("评论成功");
          const item: any = {};
          item.Comment = res.data.Comment;
          item.CreateTime = res.data.CreateTime;
          item.CustomerAva = sessionStorage.getItem("avaUrl");
          item.ID = res.data.ID;
          item.NickName = sessionStorage.getItem("nickName");
          this.commentList.splice(0, 0, item);
          this.commentStr = "";
        });
    } else {
      message.warn("请先输入评论内容");
    }
  }
}
